// @flow
import {connect} from 'react-redux';
import {Platform} from 'react-native';
import type {Props as ChooseNumberPropsType} from './ChooseNumber';
import ChooseNumber from './ChooseNumber';
import {goToNextOrderPage} from '../../../modules/SignUp';
import type {StateType} from '../../../modules/reducers';
import {isLoggedInSelector} from '../../../modules/Authentication';

const mapStateToProps = (state: StateType) => ({
  // check on Platform to avoid redirecting to idReq on app if already valid id
  nextPage: Platform.select({
    android: 'chooseSimOrEsim',
    ios: 'chooseSimOrEsim',
    web: !isLoggedInSelector(state) ? 'createAccount' : 'identityRequirements',
  }),
});

const mapDispatchToProps = dispatch => ({
  goTo: (routeName?: string) => {
    dispatch(goToNextOrderPage(routeName));
  },
});

const mergeProps = (
  stateProps,
  dispatchProps,
  ownProps,
): ChooseNumberPropsType => ({
  ...ownProps,
  goToNextPage: () => {
    dispatchProps.goTo(stateProps.nextPage);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ChooseNumber);
